import { OnePlusOneLabel } from "@/components/ui-components/OnePlusOneLabel";

interface ProductLabelProps {
  className?: string;
  title: string;
}

const ProductLabel = ({ className = "", title }: ProductLabelProps) => {
  return (
    <OnePlusOneLabel
      className={className}
      title={title}
    />
  );
};

export default ProductLabel;
